import './curve/register-ui';
import './debug/register-ui';
import './expr/register-ui';
import './gen/register-ui';
import './midi/register-ui';
import './nicepattern/register-ui';
import './resolume/nodes';
import { registerSeqUI } from './seq/ui-registration';

registerSeqUI();
